export default "__VITE_ASSET__79bba495__"